import React, { Fragment } from 'react';

import { Checkbox, Divider, Radio, Table, Typography } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';
import { functions } from 'helpers/functions';

import { Icon } from '@eduzz/ui-antd-theme';

interface IPropsState {
  paymentMethods: {
    credit_card: number;
    bankslip: number;
    paypal: number;
    pix: number;
  };
  purchaseValue: string;
}

interface IProps {
  state: IPropsState;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCustomValue: (value: any, number: any) => void;
  checkCustomValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const customValuesRender: { label: string; key: keyof IPropsState['paymentMethods'] }[] = [
  {
    label: 'Cartão de crédito',
    key: 'credit_card'
  },
  {
    label: 'Boleto',
    key: 'bankslip'
  },
  {
    label: 'Paypal',
    key: 'paypal'
  },
  {
    label: 'Pix',
    key: 'pix'
  }
];

function SendValues({ state, handleRadioChange, handleCustomValue, checkCustomValue }: IProps) {
  const { paymentMethods, purchaseValue } = state;

  const columns = [
    {
      title: 'Forma de Pagamento',
      key: 'payment',
      render: (_: any, record: (typeof customValuesRender)[0]) => (
        <Checkbox checked={paymentMethods[record.key] > 0} onChange={checkCustomValue as any} value={record.key}>
          {record.label}
        </Checkbox>
      )
    },
    {
      title: 'Valor a ser enviado',
      key: 'value',
      render: (_: any, record: (typeof customValuesRender)[0]) => (
        <CustomMaskedInput
          disableUnderline
          mask='money'
          value={functions.addMoneyMask(String(paymentMethods[record.key]))}
          onChange={(value: any) => handleCustomValue(record.key, value)}
          InputLabelProps={{ shrink: true }}
        />
      )
    }
  ];

  return (
    <Fragment>
      <div className='[&>label]:font-medium'>
        <Typography.Text className='mb-2 block font-medium'>
          Escolha em que situações o valor da compra deve ser enviado.
        </Typography.Text>
        <Radio.Group value={purchaseValue} onChange={handleRadioChange as any}>
          <div className='flex flex-col gap-2'>
            <Radio value='never'>Nunca enviar</Radio>
            <Radio value='send_purchase_value'>Sempre enviar</Radio>
            <Radio value='custom_values'>Sempre enviar com valores customizados</Radio>
          </div>
        </Radio.Group>
        {purchaseValue === 'custom_values' && (
          <Fragment>
            <Divider />
            <Table
              columns={columns}
              dataSource={customValuesRender}
              rowKey='key'
              pagination={false}
              size='small'
              className='w-full'
            />
            <Typography.Text className='text-sm'>
              <Icon.CircleAlert className='mr-2 inline' size={16} />
              Nas formas de pagamento não customizadas será enviado o valor da compra.
            </Typography.Text>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
}

export default SendValues;
